

















































































import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue';
import { SubmitContext, ValueType } from 'tdesign-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { formEqualHandler } from '@/renderer/components/dialog/setting/composition/formEqualHandler';
import storage from '@/renderer/scripts/utils/storage';
import tips from '@/renderer/scripts/utils/tips';
import { StoreKey } from '@/renderer/scripts/utils/storage/StoreKey';
import smh from '@/renderer/scripts/smh';
import { emitUpdateRequestConfig } from '@/renderer/scripts/httpRequest';
import { IS_BROWSER } from '@/common/constant/platform';
import { getDeviceName } from '@/renderer/scripts/utils/tools';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import { useBeforeLeave } from '@/renderer/components/dialog/setting/composition/useBeforeLeave';

interface IProxySetting {
  proxy: 'yes' | 'no';
  proxyAddress: string;
  proxyPort: number;
}
export default defineComponent({
  name: 'ProxySetting',
  components: {
    CloseCircleFilledIcon,
    CheckCircleFilledIcon,
  },
  setup() {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const checkStatus = ref<'success' | 'pending' | 'error' | ''>('');
    const options = [
      {
        value: 'no',
        label: i18n_t('不使用代理，直连网络'),
      },
      {
        value: 'yes',
        label: i18n_t('使用代理'),
      },
    ];
    const formData = reactive<IProxySetting>({
      proxy: 'no',
      proxyAddress: '',
      proxyPort: 0,
    });
    const rules = {
      proxy: [
        {
          required: true,
          type: 'error',
        },
      ],
      proxyAddress: [
        {
          validator: (val: ValueType) => {
            if (formData.proxy === 'yes') {
              const reg = new RegExp(
                '^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$',
              );
              const res = reg.test(formData.proxyAddress);
              return {
                result: res,
                message: i18n_t('地址格式不正确'),
                type: 'error',
              };
            }
            return {
              result: true,
              type: 'success',
            };
          },
        },
      ],
      proxyPort: [
        {
          validator: (val: ValueType) => {
            if (formData.proxy === 'yes') {
              const port = `${formData.proxyPort}`;
              const res = /^[1-9][0-9]*$/.test(port) && parseInt(port, 10) <= 65535;
              return {
                result: res,
                message: i18n_t('端口不正确'),
                type: 'error',
              };
            }
            return {
              result: true,
              type: 'success',
            };
          },
        },
      ],
    };
    const addressEditable = computed(() => formData.proxy === 'yes');
    const checkMessage = computed(() => i18n_t('测试中...'));
    // 按钮是否可点击
    const btnStatus = computed(() => ({
      test: formData.proxy === 'yes' && !_.isEmpty(formData.proxyPort) && !_.isEmpty(formData.proxyAddress),
      submit: !isEqual.value, // TODO后续在统一修改 tabs表单中的diff事件后在处理
    }));

    const { isEqual, clearFormDataCache } = formEqualHandler(formData);

    const methods = {
      onConfirm: () => {
        const form = vm.$refs?.form as any;
        form.submit();
      },
      // set data
      setStorage: _.debounce(() => storage.set(StoreKey.PROXY_SETTING, formData), 2000, {
        leading: true,
      }),
      /**
       * 验证通过后进行
       * @param validateResult 表单验证结果
       * @param firstError 验证表单中的第一个错误
       */
      onSubmit: async ({ validateResult, firstError }: SubmitContext) => {
        if (validateResult === true) {
          try {
            await methods.setStorage();
            emitUpdateRequestConfig();
            const proxy =
              formData.proxy === 'yes'
                ? {
                    host: formData.proxyAddress,
                    port: formData.proxyPort,
                  }
                : false;
            smh.changeProxy(proxy);
            logger.ui.info(
              i18n_t('用户修改proxy，修改后值为：{slot1}', {
                slot1: JSON.stringify(proxy),
              }),
            );
            clearFormDataCache();
            tips.success(i18n_t('保存成功！'));
          } catch (e) {
            tips.error(i18n_t('保存失败！'));
          }
        } else {
          firstError && tips.error(firstError);
        }
      },
      // 测试连接
      testConnect: async () => {
        checkStatus.value = 'pending';
        let httpsAgent;
        let httpAgent;
        let tunnel: any = null;
        if (!IS_BROWSER) {
          tunnel = (window.parent as any).require('tunnel-agent');
        }
        if (tunnel) {
          httpsAgent = tunnel.httpsOverHttp({
            proxy: {
              host: formData.proxyAddress,
              port: formData.proxyPort,
            },
          });
          httpAgent = tunnel.httpOverHttp({
            proxy: {
              host: formData.proxyAddress,
              port: formData.proxyPort,
            },
          });
        }
        try {
          // TODO 找一个不会失败的请求 logan
          const res = await smh.api.getQRCode(getDeviceName(), CONSTANT_URL.currentDomain, httpsAgent, httpAgent);
          checkStatus.value = 'success';
        } catch (e) {
          checkStatus.value = 'error';
        }
      },
      resetCheckResult: () => {
        checkStatus.value = '';
      },
      // init data
      init: () => {
        // read data
        const storageProxySetting: IProxySetting = storage.get<IProxySetting>(StoreKey.PROXY_SETTING);
        formData.proxyAddress = storageProxySetting.proxyAddress;
        formData.proxyPort = storageProxySetting.proxyPort;
        formData.proxy = storageProxySetting.proxy;
      },
    };

    const { toggleMethods, confirming } = useBeforeLeave();
    // proxy发生变化之后，清除多余的错误信息
    watch(formData, (val, oldValue) => {
      methods.resetCheckResult();
    });
    methods.init();
    clearFormDataCache();
    return {
      confirming,
      options,
      checkStatus,
      checkMessage,
      btnStatus,
      isEqual,
      rules,
      addressEditable,
      formData,
      toggleMethods,
      ...methods,
    };
  },
});
